import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { Check, Home as HomeIcon, Armchair, Blinds, Layers, Grid3x3, Mountain, Palette, Sparkles, Star, Flower2, BoxIcon } from 'lucide-react';
const SERVICE_CATEGORIES = [{
  name: 'Accessories',
  description: 'Curated selection of decorative accessories, artwork, and finishing touches that bring personality and polish to any space.',
  link: '/23m8/accessories.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2FAccessories2.JPG'
}, {
  name: 'Apparel',
  description: 'Boutique clothing and jewelry collection featuring timeless pieces that complement your personal style.',
  link: '/23m8/apparel.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2Fapparel.JPG'
}, {
  name: 'Bathrooms',
  description: 'Complete bathroom design from layout planning to fixture selection, creating spa-like retreats in your home.',
  link: '/23m8/bathrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBathrooms%2FBathroom5.jpg'
}, {
  name: 'Bedrooms',
  description: "Restful bedroom designs that balance comfort and style, from master suites to guest rooms and children's spaces.",
  link: '/23m8/bedrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FBedrooms1.JPG'
}, {
  name: 'Before & After',
  description: 'Transformative design projects that showcase the power of thoughtful planning and expert execution.',
  link: '/23m8/before-after.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBefore%20%26%20After%2F140508121027.jpg'
}, {
  name: 'Commercial',
  description: 'Professional interior design for offices, retail spaces, and hospitality venues that enhance your brand and customer experience.',
  link: '/23m8/commercial.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013937.jpg'
}, {
  name: 'Dining Rooms',
  description: 'Elegant dining spaces designed for both everyday meals and special occasions, with attention to flow and functionality.',
  link: '/23m8/dining-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014171.jpg'
}, {
  name: 'Furniture',
  description: 'Quality furniture selection and custom pieces that anchor your rooms with style and substance.',
  link: '/23m8/furniture.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FIMG_9817.JPG'
}, {
  name: 'Kitchens',
  description: 'Kitchen design that balances beauty and function, from layout optimization to material selection and styling.',
  link: '/23m8/kitchens.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014168.jpg'
}, {
  name: 'Lighting',
  description: 'Lighting design and fixture selection that sets the mood, highlights architecture, and enhances daily living.',
  link: '/23m8/lighting.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flighting%20and%20bathroom.jpg'
}, {
  name: 'Living Rooms',
  description: 'Inviting living spaces designed for how you actually live, with comfortable seating arrangements and thoughtful layouts.',
  link: '/23m8/living-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014111.jpg'
}, {
  name: 'Lower Levels',
  description: 'Basement and lower level transformations that maximize square footage with family rooms, home theaters, and recreation spaces.',
  link: '/23m8/lower-levels.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flower%20level.jpg'
}, {
  name: 'Seminars and Events',
  description: 'Educational workshops and design events where we share our expertise and connect with the community.',
  link: '/23m8/seminars-and-events.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FIMG_3233.jpg'
}, {
  name: 'Staging',
  description: 'Professional real estate staging that helps homes sell faster and for more by showcasing their best features.',
  link: '/23m8/staging.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FBlog%20Images%2Fclutter%20free.jpg'
}, {
  name: 'Window Treatments',
  description: 'Custom drapery, blinds, and shades designed to enhance your windows while providing privacy and light control.',
  link: '/23m8/window-treatments.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013895.jpg'
}];
export function Services() {
  return <Layout data-id="element-612">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-613">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-614">
          <img src="https://cdn.magicpatterns.com/uploads/uC7yBiRHmqgmNVwY8ECDES/services_bg.jpg" alt="Down Home Interiors Services" className="w-full h-full object-cover object-center" data-id="element-615" />
          <div className="absolute inset-0 bg-white/80" data-id="element-616" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-617">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-618">
            What We Offer
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-619">
            Interior Design Services &<br data-id="element-620" />
            <span className="italic" data-id="element-621">Curated Retail</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-622">
            From full-service interior design and professional home staging to
            curated home décor and retail offerings, we provide thoughtful
            design solutions tailored to each client and every space.
          </p>
        </div>
      </section>

      {/* Design Services & Finishing Touches */}
      <section className="pb-20 pt-20 px-4 bg-white border-b border-taupe-200" data-id="element-623">
        <div className="max-w-6xl mx-auto text-center" data-id="element-624">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-625">
            Interior Design & Finishing Touches
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-626">
            From concept through finishing details, we offer a wide range of
            interior design services tailored to your home.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-627">
            {[{
            name: 'Interior Design',
            icon: HomeIcon
          }, {
            name: 'Furniture Selection',
            icon: Armchair
          }, {
            name: 'Window Treatments',
            icon: Blinds
          }, {
            name: 'Custom Cabinetry',
            icon: BoxIcon
          }, {
            name: 'Flooring',
            icon: Layers
          }, {
            name: 'Tile',
            icon: Grid3x3
          }, {
            name: 'Granite, Quartz, Quartzite',
            icon: Mountain
          }, {
            name: 'Paint Consults',
            icon: Palette
          }, {
            name: 'Home Staging',
            icon: Sparkles
          }, {
            name: 'Custom Accessories',
            icon: Star
          }, {
            name: 'Custom Florals',
            icon: Flower2
          }].map(service => <div key={service.name} className="group flex flex-col items-center justify-center p-5 bg-cream-50/50 border border-taupe-100 rounded-sm hover:shadow-md hover:bg-white hover:border-sage-200 transition-all duration-300" data-id="element-628">
                <service.icon className="h-7 w-7 text-sage-500 mb-3 group-hover:text-sage-600 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} data-id="element-629" />
                <span className="text-charcoal-900 text-base font-serif tracking-wide group-hover:text-sage-900 transition-colors" data-id="element-630">
                  {service.name}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Service Categories Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-631">
        <div className="max-w-7xl mx-auto" data-id="element-632">
          <div className="text-center mb-16" data-id="element-633">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-634">
              Comprehensive Design Solutions
            </h2>
            <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6 max-w-4xl mx-auto" data-id="element-635">
              Each category below represents an area of expertise where we've
              completed hundreds of projects over the past 20 years. Whether you
              need full-service design, retail products, or professional
              staging, we bring the same level of care and attention to every
              engagement.
            </p>
            <p className="text-lg text-charcoal-900/70 leading-relaxed max-w-4xl mx-auto" data-id="element-636">
              Browse our focus areas to understand the scope of what we offer,
              then explore our portfolio to see real examples of our work.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-637">
            {SERVICE_CATEGORIES.map(service => <div key={service.name} className="bg-white border border-taupe-200 overflow-hidden hover:shadow-soft transition-shadow duration-300" data-id="element-638">
                {/* Service Image */}
                <a href={service.link} className="block" data-id="element-639">
                  <img src={service.image} alt={service.name} className="aspect-[4/3] w-full object-cover border-b border-taupe-200" data-id="element-640" />
                </a>

                <div className="p-6" data-id="element-641">
                  <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-642">
                    {service.name}
                  </h3>
                  <p className="text-charcoal-900/70 leading-relaxed text-sm mb-4" data-id="element-643">
                    {service.description}
                  </p>
                  <a href={service.link} data-id="element-644">
                    <Button variant="ghost" size="sm" className="text-xs" data-id="element-645">
                      View Examples →
                    </Button>
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 px-4 bg-white" data-id="element-646">
        <div className="max-w-5xl mx-auto" data-id="element-647">
          <div className="text-center mb-16" data-id="element-648">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-649">
              Our Design Process
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-650">
              How we bring your vision to life
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-651">
            {[{
            step: '01',
            title: 'Consultation',
            description: 'We start by listening. Understanding your lifestyle, preferences, and goals is essential to creating spaces that work for you.'
          }, {
            step: '02',
            title: 'Design Development',
            description: 'We create detailed plans, select materials and furnishings, and present options that align with your vision and budget.'
          }, {
            step: '03',
            title: 'Sourcing & Ordering',
            description: 'Leveraging our extensive vendor relationships, we source quality products and manage all ordering, tracking, and coordination.'
          }, {
            step: '04',
            title: 'Installation',
            description: 'We oversee delivery, placement, and styling to ensure every detail is perfect. Your satisfaction is our priority.'
          }].map(phase => <div key={phase.step} className="text-center" data-id="element-652">
                <div className="text-4xl font-serif text-sage-500 mb-4" data-id="element-653">
                  {phase.step}
                </div>
                <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-654">
                  {phase.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed text-sm" data-id="element-655">
                  {phase.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-656">
        <div className="max-w-5xl mx-auto" data-id="element-657">
          <div className="text-center mb-16" data-id="element-658">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-659">
              The Down Home Difference
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-660">
            {['Personalized service from an experienced owner-operator', 'Over 20 years of proven design expertise', 'Full-service approach from concept to installation', 'Local retail store with curated home décor and apparel', 'Extensive network of trusted contractors and craftspeople', 'Timeless design philosophy that ages gracefully', 'Transparent pricing and clear communication', 'Commitment to your satisfaction and long-term happiness'].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-661">
                <div className="flex-shrink-0 w-6 h-6 bg-sage-500 rounded-full flex items-center justify-center mt-1" data-id="element-662">
                  <Check className="text-white" size={14} data-id="element-663" />
                </div>
                <p className="text-lg text-charcoal-900/80" data-id="element-664">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-665">
        <div className="max-w-4xl mx-auto text-center" data-id="element-666">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-667">
            Let's Discuss Your Project
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-668">
            Whether you're planning a complete renovation or looking for design
            guidance, we're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-669">
            <Link to="/interior-design-portfolio" data-id="element-670">
              <Button size="lg" className="min-w-[200px]" data-id="element-671">
                View Our Portfolio
              </Button>
            </Link>
            <Link to="/contact" data-id="element-672">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-673">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}